const DEVICE_ID_KEY = "clamphook-device-id";

/**
 * A persistent, client-generated id -- not a real hardware fingerprint,
 * just enough to let the backend's trial anti-abuse check (xylene/end_user/
 * trial/routes.py) notice "this browser already claimed a trial under a
 * different account" without requiring any new permissions.
 */
export function getOrCreateDeviceId(): string {
  if (typeof window === "undefined") return "";
  try {
    let id = localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
      id =
        typeof crypto !== "undefined" && "randomUUID" in crypto
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
  } catch {
    return "";
  }
}
